<template>
  <div style="min-height: 100vh; position: relative">
    <!-- <v-container fluid> -->
    <Typography h2 bold label="ภาพรวม" />
    <v-layout wrap class="mb-2" style="display: flex; align-items: center">
      <v-flex xs12 sm6 style="display: flex;">
        <!-- <div  style="width: 50%">
          <VueDatePicker
            v-model="selectedDate"
            @input="
              filter = 'all'
              getSummary()
            "
            :range-presets="presets"
            placeholder="Début - Fin"
            range=
            fullscreen-mobile
            validate
            :locale="{ lang: 'en' }"
          />
        </div> -->
        <div class="form-control" style="margin-right: 6px;width: 55%">
          <date-picker
            range
            @input="
              filter = 'all'
              getSummary()
            "
            :shortcuts="shortcuts"
            :append-to-body="false"
            :clearable="false"
            :editable="false"
            input-class="dateSearch"
            name="DateSearch"
            v-model="selectedDate"
            valueType="date"
            format="DD/MM/YYYY"
            placeholder="Début - Fin"
          >
          </date-picker>
        </div>
      </v-flex>
      <!-- <v-flex xs12 sm6>
        <div style="width: 50%">
          <VueDatePicker
            v-model="date"
            :min-date="minDate"
            :max-date="maxDate"
            :range-presets="presets"
            placeholder="Début - Fin"
            range
            fullscreen-mobile
            validate
          />
        </div>
      </v-flex> -->

      <!-- <v-flex xs12 sm6>
        <v-btn
          depressed
          :outline="filter != 'all'"
          :color="filter == 'all' ? 'primary' : 'grey'"
          @click="
            filter = 'all'
            getSummary()
          "
          class="ma-0 mr-1 mb-1"
          >{{ $t('All') }}</v-btn
        >
        <v-btn
          depressed
          :outline="filter != 'line'"
          :color="filter == 'line' ? 'primary' : 'grey'"
          @click="
            filter = 'line'
            getSummary()
          "
          class="ma-0 mr-1 mb-1"
        >
          <i class="fab fa-line mr-1"></i>
          {{ $t('Line') }}
        </v-btn>
      </v-flex> -->
      <v-flex xs12 sm6 class="text-sm-right">
        <template v-if="loading">
          <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
        </template>
        <template v-else>
          <!-- <v-btn
            v-if="$store.getters.getPackage != 'premium'"
            outline
            v-tooltip.top="'Unlock to PREMIUM plan'"
            color="grey"
            class="ma-0 mb-1"
          >
            <i class="fas fa-file-export mr-1"></i>
            <span class="mr-2">{{ $t('export') }}</span>
            <v-premium-lock :inline="true"></v-premium-lock>
          </v-btn>
          
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            @click="exportDashboard"
            color="grey"
            outline
            class="ma-0 mb-1"
            :disabled="isError"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
          </v-btn> -->
          <v-btn
            variant="outlined"
            v-tooltip="'ส่งออกข้อมูล'"
            @click="modalExport = true"
            :loading="loading"
            icon
            color="#BECCDB"
            style="border-radius: 50% !important"
            :disabled="isError"
          >
            <img
              src="/static/img/exportfilter.png"
              alt
              class="responsive-img"
              style="height: 16px"
            />
          </v-btn>
        </template>
      </v-flex>
    </v-layout>

    <!-- <date-filter
      v-model="selectedDate"
      @onSelected="getSummary"
      :default-filter="'last_15_days'"
    ></date-filter> -->
    <!-- <h3 class="title mt-5 mb-2">{{ $t('Total number of users since installing chatbot') }}</h3> -->
    <Typography h2 bold label="จำนวนผู้ใช้" class="mt-4" />
    <!-- <p class="title">{{$t('Total number of users since installing chatbot')}}</p> -->
    <v-layout wrap>
      <v-flex xs12 sm12 md5 lg5 class="pa-1">
        <v-card
          style="border-radius: 10px; height: 100%; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15)"
        >
          <v-card-title>
            <!-- <span>{{ $t('total user') }}</span> -->
          </v-card-title>
          <div class="body">
            <div class style="position: relative">
              <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
              <template v-if="totaluserSeries">
                <div style="max-width: 350px; margin: auto">
                  <apexchart
                    ref="totaluser"
                    type="pie"
                    :options="totaluser"
                    :series="totaluserSeries"
                    height="380"
                  ></apexchart>
                </div>
              </template>
            </div>
          </div>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md7 lg7>
        <v-layout wrap class="mb-3">
          <v-flex xs12 sm12 md12 lg12 class="pa-1">
            <stat-card v-model="summary.totalusers" :loading="loading" :head="true" label="คน">
              <Typography h5 medium :label="$t('total user')"
            /></stat-card>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <!-- <v-flex xs12 sm6 md6 lg12 class="pa-1">
            <stat-card v-model="summary.totalusers" :loading="loading">
              <Typography h5 medium :label="$t('total user')"
            /></stat-card>
          </v-flex> -->
          <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
            <stat-card v-model="totaluserSeries[2]" :loading="loading" label="คน">
              <!-- {{ $t('no gender') }} -->
              <Typography h5 medium :label="$t('no gender')" />
              <span
                class="ml-2"
                style="color: #d4d4d4"
                v-tooltip.top="
                  $t('Number of non-male and non-female users who talked with chatbot (All time)')
                "
              >
                <i class="fas fa-info-circle"></i>
              </span>
            </stat-card>
          </v-flex>
          <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
            <stat-card v-model="totaluserSeries[0]" :loading="loading" label="คน">
              <!-- {{ $t('male') }} -->
              <Typography h5 medium :label="$t('male')" />
              <span
                class="ml-2"
                style="color: #d4d4d4"
                v-tooltip.top="$t('Number of male users who talked with chatbot (All time)')"
              >
                <i class="fas fa-info-circle"></i>
              </span>
            </stat-card>
          </v-flex>
          <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
            <stat-card v-model="totaluserSeries[1]" :loading="loading" label="คน">
              <!-- {{ $t('Female') }} -->
              <Typography h5 medium :label="$t('Female')" />
              <span
                class="ml-2"
                style="color: #d4d4d4"
                v-tooltip.top="$t('Number of female users who talked with chatbot (All time)')"
              >
                <i class="fas fa-info-circle"></i>
              </span>
            </stat-card>
          </v-flex>
          <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
            <stat-card
              v-model="summary.activeusers"
              :loading="loading"
              :disabled="!selectedBot.status"
              label="คน"
            >
              <!-- {{ $t('active users') }} -->
              <Typography h5 medium :label="$t('active users')" />
              <span
                class="ml-2"
                style="color: #d4d4d4"
                v-tooltip.top="
                  $t('Number of users who talked with chatbot during') +
                    ' ' +
                    dateFormat(selectedDate[0], 'DD/MM/YYYY') +
                    ' - ' +
                    dateFormat(selectedDate[1], 'DD/MM/YYYY')
                "
              >
                <i class="fas fa-info-circle"></i>
              </span>
            </stat-card>
          </v-flex>
          <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
            <stat-card
              v-model="summary.newusers"
              :loading="loading"
              :disabled="!selectedBot.status"
              label="คน"
            >
              <!-- {{ $t('new users') }} -->
              <Typography h5 medium :label="$t('new users')" />
              <span
                class="ml-2"
                style="color: #d4d4d4"
                v-tooltip.top="
                  $t('Number of new users who talked with chatbot during') +
                    ' ' +
                    dateFormat(selectedDate[0], 'DD/MM/YYYY') +
                    ' - ' +
                    dateFormat(selectedDate[1], 'DD/MM/YYYY')
                "
              >
                <i class="fas fa-info-circle"></i>
              </span>
            </stat-card>
          </v-flex>
          <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
            <stat-card
              v-model="summary.existingusers"
              :loading="loading"
              :disabled="!selectedBot.status"
              label="คน"
            >
              <Typography h5 medium :label="$t('existing users')" />
              <!-- {{ $t('existing users') }} -->
              <span
                class="ml-2"
                style="color: #d4d4d4"
                v-tooltip.top="
                  $t('active users') +
                    ' - ' +
                    $t('new users') +
                    ' ' +
                    dateFormat(selectedDate[0], 'DD/MM/YYYY') +
                    ' - ' +
                    dateFormat(selectedDate[1], 'DD/MM/YYYY')
                "
              >
                <i class="fas fa-info-circle"></i>
              </span>
            </stat-card>
          </v-flex>
          <v-flex xs12 v-if="!selectedBot.status">
            <div
              class="caption grey lighten-3 py-1 px-2 ma-1 text-xs-center"
              style="border-radius: 50px"
            >
              <Typography
                h5
                medium
                :label="
                  $t('Information will not be recorded in analytics if the bot is inactivated')
                "
              />
              <!-- {{ $t('Information will not be recorded in analytics if the bot is inactivated') }} -->
            </div>
          </v-flex>

          <v-divider />
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- <v-layout wrap class="hidden-sm-and-up mt-3">
      <v-flex xs12 sm6 md6 lg6 fill-height class="pa-1 pl-2">
        <h3 class="title">{{ $t('Current number of messages received') }}</h3>
        <stat-card v-model="summary.activemessages" :loading="loading">
          {{ $t('active messages') }}
          <span
            style="color: #d4d4d4"
            v-tooltip.top="
              $t('Number of messages that chatbot had replied during') +
              ' ' +
              dateFormat(selectedDate.start, 'DD/MM/YYYY') +
              ' - ' +
              dateFormat(selectedDate.end, 'DD/MM/YYYY')
            "
          >
            <i class="fas fa-info-circle"></i>
          </span>
        </stat-card>
      </v-flex>
    </v-layout> -->

    <v-layout wrap class="hidden-xs-only mt-5">
      <v-flex xs12 sm12 md12 lg12 fill-height class="pa-1 pl-2">
        <!-- <h3 class="title">{{ $t('Current number of messages received') }}</h3> -->
        <Typography h2 bold :label="$t('Current number of messages received')" />
      </v-flex>

      <v-flex sm12 fill-height class="pa-1 pr-1">
        <stat-card v-model="summary.activemessages" :loading="loading" label="ข้อความ">
          <!-- {{ $t('active messages') }} -->
          <Typography h5 medium :label="$t('active messages')" />
          <span
            style="color: #d4d4d4"
            v-tooltip.top="
              $t('Number of messages that chatbot had replied during') +
                ' ' +
                dateFormat(selectedDate[0], 'DD/MM/YYYY') +
                ' - ' +
                dateFormat(selectedDate[1], 'DD/MM/YYYY')
            "
          >
            <i class="fas fa-info-circle"></i>
          </span>
        </stat-card>
      </v-flex>
    </v-layout>

    <!-- <h3 class="title mt-5 mb-2">{{ $t('Comment') }}</h3> -->
    <v-layout wrap>
      <!--         <v-flex xs12 sm6 md4 lg3 class="pa-1">
          <stat-card v-model="summary.totalreplycomments" :loading="loading">{{
            $t('Total reply comments')
          }}</stat-card>
        </v-flex>-->
      <!--         <v-flex xs12 sm6 md4 lg3 class="pa-1">
          <stat-card v-model="summary.totalreplyinbox" :loading="loading">{{
            $t('Total reply inbox')
          }}</stat-card>
        </v-flex>-->
      <!--         <v-flex xs12 sm6 md4 lg3 class="pa-1">
          <stat-card v-model="summary.totalhidecomment" :loading="loading">{{
            $t('Total hide comments')
          }}</stat-card>
        </v-flex>-->
      <!-- <v-flex xs12 sm6 md4 lg4 class="pa-1">
          <stat-card v-model="summary.activereplycomments" :loading="loading">
            {{ $t('Active reply comments') }}
          </stat-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg4 class="pa-1">
          <stat-card v-model="summary.activereplyinbox" :loading="loading">
            {{ $t('Active reply inbox') }}
          </stat-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg4 class="pa-1">
          <stat-card v-model="summary.activehidecomment" :loading="loading">
            {{ $t('Active hide comments') }}
          </stat-card>
        </v-flex> -->
      <v-flex xs12 sm6 md4 lg3 class="pa-1"></v-flex>
    </v-layout>
    <!-- </v-container> -->
    <v-dialog v-model="modalExport" persistent width="400px">
      <v-card style="border-radius: 10px">
        <div class="pa-3">
          <div style="display: flex; justify-content: space-between">
            <div></div>
            <div></div>

            <v-icon style="display: flex; align-items: center" @click="modalExport = false"
              >close</v-icon
            >
          </div>
          <div class="rsu">
            <v-layout column wrap justify-center align-center class="mb-3">
              <img
                src="/static/img/Export.png"
                alt
                class="responsive-img mb-1"
                style="height: 70px"
              />
              <Typography h2 bold label="ส่งออกข้อมูล" />
              <Typography h5 medium label="คุณแน่ใจหรือไม่ว่าต้องการส่งออกข้อมูลตามที่เลือก" />
            </v-layout>
            <div class="text-xs-center">
              <div class="text-xs-center rsu">
                <v-btn
                  :loading="loading"
                  class="rsu"
                  round
                  small
                  outline
                  color="primary"
                  @click.stop="modalExport = false"
                  >ยกเลิก</v-btn
                >
                <v-btn
                  class="rsu"
                  :loading="loading"
                  round
                  small
                  depressed
                  style="color: #ffef01"
                  color="primary"
                  @click.stop="exportDashboard"
                  >ยืนยัน</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <div class="mt-5 mb-5"></div>
  </div>
</template>

<script>
import DateFilter from './DateFilter'
import { mapGetters } from 'vuex'
import api from '@/api'
import Typography from '@/components/elements/Typography.vue'
import moment from 'moment'
import numeral from 'numeral'

import VueApexCharts from 'vue-apexcharts'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Multiselect from 'vue-multiselect'
import StatCard from './StatCard'
import DashboardGraphLoading from './DashboardGraphLoading'
import DatePicker from 'vue2-datepicker'
// import { VueDatePicker } from '@mathieustan/vue-datepicker'
import XLSX from 'xlsx'

export default {
  components: {
    DateFilter,
    StatCard,
    ScaleLoader,
    PulseLoader,
    apexchart: VueApexCharts,
    DashboardGraphLoading,
    Typography,
    Multiselect,
    DatePicker
    // VueDatePicker
  },
  data: function() {
    return {
      isError: false,
      date: new Date(),
      // currentDate: new Date(),
      modalExport: false,
      summary: {
        totalmessages: 0,
        activemessages: 0,
        activeusers: 0,
        totalusers: 0,
        newusers: 0
      },
      search: {
        nameAll: '',
        date: ''
      },
      loading: true,
      filter: 'all',
      totaluserSeries: [0, 0, 0],
      totaluser: {
        chart: {
          type: 'pie'
          // height: 350
        },
        labels: [this.$t('male'), this.$t('female'), this.$t('no gender')],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        legend: {
          show: true,
          position: 'bottom'
        }
      },
      selectedDate: [new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), new Date(new Date())]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    shortcuts() {
      const currentDate = new Date()
      const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000)
      const fortyEightHoursAgo = new Date(Date.now() - 48 * 60 * 60 * 1000)
      const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
      return [
        {
          text: '24 ชั่วโมงที่แล้ว',
          onClick() {
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            const start = new Date(
              twentyFourHoursAgo.getFullYear(),
              twentyFourHoursAgo.getMonth(),
              twentyFourHoursAgo.getDate(),
              twentyFourHoursAgo.getHours(),
              twentyFourHoursAgo.getMinutes(),
              twentyFourHoursAgo.getSeconds()
            )

            const date = [start, end]
            return date
          }
        },
        {
          text: '48 ชั่วโมงที่แล้ว',
          onClick() {
            const start = new Date(
              fortyEightHoursAgo.getFullYear(),
              fortyEightHoursAgo.getMonth(),
              fortyEightHoursAgo.getDate(),
              fortyEightHoursAgo.getHours(),
              fortyEightHoursAgo.getMinutes(),
              fortyEightHoursAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )

            const date = [start, end]
            return date
          }
        },
        {
          text: 'อาทิตย์ที่แล้ว',
          onClick() {
            const start = new Date(
              oneWeekAgo.getFullYear(),
              oneWeekAgo.getMonth(),
              oneWeekAgo.getDate(),
              oneWeekAgo.getHours(),
              oneWeekAgo.getMinutes(),
              oneWeekAgo.getSeconds()
            )
            const end = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate(),
              currentDate.getHours(),
              currentDate.getMinutes(),
              currentDate.getSeconds()
            )
            // return a Date
            const date = [start, end]
            return date
          }
        },
        {
          text: '15 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000)
            const end = new Date(currentDate)
            // return a Date
            const date = [start, end]
            return date
          }
        },
        {
          text: 'เดือนที่แล้ว',
          onClick() {
            const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
            const end = new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              new Date().getDate()
            )
            // return a Date
            const date = [start, end]
            return date
          }
        },
        {
          text: '365 วันที่แล้ว',
          onClick() {
            const start = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
            const end = new Date()
            // return a Date
            const date = [start, end]
            return date
          }
        }
      ]
    }
  },
  mounted: function() {
    this.getSummary()
  },
  methods: {
    dateFormat: function(date, format) {
      return moment(date).format(format)
    },
    getSummary: function() {
      let vm = this
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: moment(this.selectedDate[0]).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate[1]).format('YYYY-MM-DD'),
        app: this.filter != 'all' ? this.filter : null
      }
      vm.isError = false
      vm.loading = true
      api.getDashboardSummary(data, function(error, response) {
        if (error) {
          vm.$swal.fire({
            title: vm.$t('Please refresh the page and try again.'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          vm.isError = true
          vm.loading = false
          return
        }
        if (response.data) {
          if (response.data.length > 0) {
            vm.summary.totalmessages = response.data[0].totalmessages
            vm.summary.activemessages = response.data[0].activemessages
            try {
              vm.summary.activeusers =
                parseInt(response.data[0].activeusers) > parseInt(response.data[0].newusers)
                  ? response.data[0].activeusers
                  : response.data[0].newusers
            } catch (error) {
              vm.summary.activeusers = response.data[0].activeusers
            }
            vm.summary.totalusers = response.data[0].totalusers
            vm.summary.newusers = response.data[0].newusers
            vm.summary.existingusers = vm.summary.activeusers - vm.summary.newusers

            vm.summary.totalhidecomment = response.data[0].totalhidecomment
            vm.summary.totalreplycomments = response.data[0].totalreplycomments
            vm.summary.totalreplyinbox = response.data[0].totalreplyinbox
            vm.summary.activehidecomment = response.data[0].activehidecomment
            vm.summary.activereplycomments = response.data[0].activereplycomments
            vm.summary.activereplyinbox = response.data[0].activereplyinbox

            vm.totaluserSeries = [
              parseInt(response.data[0].totalusers_male),
              parseInt(response.data[0].totalusers_female),
              parseInt(response.data[0].totalusers_other)
            ]
          } else {
            vm.summary.totalmessages = 0
            vm.summary.activemessages = 0
            vm.summary.activeusers = 0
            vm.summary.totalusers = 0
            vm.summary.newusers = 0

            vm.totaluserSeries = [0, 0, 0]
          }
        }
        vm.$nextTick(function() {
          vm.loading = false
        })
      })
    },
    exportDashboard: function() {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }

      let json = []
      json.push(['(Since installing chatbot)'])

      json.push([this.$t('total user'), numeral(vm.summary.totalusers).format('0,0')])
      json.push([
        this.$t('no gender'),
        numeral(parseInt(vm.totaluserSeries[2])).format('0,0'),
        numeral((vm.totaluserSeries[2] * 100) / vm.summary.totalusers).format('0.0') + '%'
      ])
      json.push([
        this.$t('male'),
        numeral(parseInt(vm.totaluserSeries[0])).format('0,0'),
        numeral((vm.totaluserSeries[0] * 100) / vm.summary.totalusers).format('0.0') + '%'
      ])
      json.push([
        this.$t('female'),
        numeral(parseInt(vm.totaluserSeries[1])).format('0,0'),
        numeral((vm.totaluserSeries[1] * 100) / vm.summary.totalusers).format('0.0') + '%'
      ])

      json.push([this.$t('active users'), numeral(vm.summary.activeusers).format('0,0')])
      json.push([this.$t('new users'), numeral(vm.summary.newusers).format('0,0')])
      json.push([
        this.$t('existing users'),
        numeral(vm.summary.activeusers - vm.summary.newusers).format('0,0')
      ])
      json.push([])

      json.push([
        `${this.$t('from')} ` +
          moment(vm.selectedDate[0]).format('DD/MM/YYYY HH:mm') +
          ` ${this.$t('to')} ` +
          moment(vm.selectedDate[1]).format('DD/MM/YYYY HH:mm')
      ])
      json.push(['Total Users by active user'])
      // json.push(['Total Messages', numeral(vm.summary.totalmessages).format('0,0')])
      json.push([this.$t('active messages'), numeral(vm.summary.activemessages).format('0,0')])

      const dataWS = XLSX.utils.aoa_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'dashboard.xlsx')

      // csvContent +=
      //   'From,"' +
      //   moment(vm.selectedDate.start).format('DD/MM/YYYY') +
      //   '",To,"' +
      //   moment(vm.selectedDate.end).format('DD/MM/YYYY') +
      //   '"\r\n'
      // csvContent += '\r\n'
      // csvContent += 'Total Users,"' + numeral(vm.summary.totalusers).format('0,0') + '"\r\n'
      // csvContent +=
      //   'No Gender Users,"' +
      //   numeral(parseInt(vm.totaluserSeries[2])).format('0,0') +
      //   '","' +
      //   numeral((vm.totaluserSeries[2] * 100) / vm.summary.totalusers).format('0.0') +
      //   '%"\r\n'
      // csvContent +=
      //   'Male Users,"' +
      //   numeral(parseInt(vm.totaluserSeries[0])).format('0,0') +
      //   '","' +
      //   numeral((vm.totaluserSeries[0] * 100) / vm.summary.totalusers).format('0.0') +
      //   '%"\r\n'
      // csvContent +=
      //   'Female Users,"' +
      //   numeral(parseInt(vm.totaluserSeries[1])).format('0,0') +
      //   '","' +
      //   numeral((vm.totaluserSeries[1] * 100) / vm.summary.totalusers).format('0.0') +
      //   '%"\r\n'
      // csvContent += + '"\r\n'
      // csvContent += + '"\r\n'
      // csvContent += + '"\r\n'
      // csvContent += + '"\r\n'
      // csvContent += '\r\n'
      this.modalExport = false
      // vm.exportCsv(csvContent, 'crm')
    }
  },
  filters: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="scss" scoped>
.totalmessagex {
  border-right: 1px solid #cecece;
  padding-right: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/StatSummary.vue